import axios from '../helpers/axios'
import { logError } from '../services';
import { IResponse, IPunchlistTemplate } from '../models';

export const getPunchlistTemplates = async (filters?: {
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  searchText?: string;
}): Promise<IResponse<IPunchlistTemplate[]>> => {
  try {
    const { data } = await axios.get(`/api/punchlist-templates`, {
      params: filters
    });
    return data;
  } catch (error: any) {
    logError(error, 'getPunchlistTemplates failed');
    return Promise.reject(error.response.data);
  }
};

export const createPunchlistTemplate = async (payload): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/punchlist-templates`, payload);
    return data;
  } catch (error: any) {
    logError(error, 'createPunchlistTemplate failed');
    return Promise.reject(error.response.data);
  }
};

export const deletePunchlistTemplate = async (id: number): Promise<any> => {
  try {
    const { data } = await axios.delete(`/api/punchlist-templates/${id}`);
    return data;
  } catch (error: any) {
    logError(error, 'deletePunchlistTemplate failed');
    return Promise.reject(error.response.data);
  }
};

export const getPunchlistTemplate = async (id: number): Promise<IPunchlistTemplate> => {
  try {
    const { data } = await axios.get(`/api/punchlist-templates/${id}`);
    return data;
  } catch (error: any) {
    logError(error, 'getPunchlistTemplate failed');
    return Promise.reject(error.response.data);
  }
};

export const updatePunchlistTemplate = async (id: number, payload): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/punchlist-templates/${id}`, payload);
    return data;
  } catch (error: any) {
    logError(error, 'updatePunchlistTemplate failed');
    return Promise.reject(error.response.data);
  }
};

